import { Mutator } from 'final-form';

import { ExtendedProjectConfiguration } from '../ValidationRule/types';

export const deleteUrl: Mutator<ExtendedProjectConfiguration> = (args, state, utils) => {
  utils.changeValue(state, 'password_reset_callback_url', () => '');
};
